import Routes from "security-app/routing/Routes";
export const PAGE_NAV_TITLE = "Anomalies";
const anomalyPageNavigation = {
  description: PAGE_NAV_TITLE,
  children: [
    {
      description: "Anomaly Detectors",
      titleKey: "enterprise_navigation:anomalies.anomaly_detectors",
      path: Routes.ANOMALIES.DETECTORS.LIST
    }
  ]
};
export default anomalyPageNavigation;
